import type { FC } from 'react';
import { useRouter } from 'next/router';
import { useLoadBlockGames } from '@mwl/core-lib';
import { GameCard } from '@/components/GameCard/GameCard';
import { PerfectScrollbar } from '@/components/PerfectScrollbar/PerfectScrollbar';
import { routes } from '@/constants';
import { loadCasinoRecommendedGames, loadLiveCasinoRecommendedGames } from '../../../../utils/loadGames';
import styles from './BottomSection.module.scss';
export const BottomSection: FC = () => {
  const router = useRouter();
  const isLiveCasinoPage = router.pathname.startsWith(routes.liveCasino.home);
  const loadMethod = isLiveCasinoPage ? loadLiveCasinoRecommendedGames : loadCasinoRecommendedGames;
  const {
    items: games
  } = useLoadBlockGames({
    loadMethod
  });
  return <div className={styles.root} data-sentry-component="BottomSection" data-sentry-source-file="BottomSection.tsx">
      <PerfectScrollbar className={styles.slider} options={{
      suppressScrollX: false,
      suppressScrollY: true
    }} data-sentry-element="PerfectScrollbar" data-sentry-source-file="BottomSection.tsx">
        {games.map(game => <GameCard key={game.id} className={styles.slide} {...game} />)}
      </PerfectScrollbar>
    </div>;
};